import { render, staticRenderFns } from "./Index-review.vue?vue&type=template&id=fc2d4a1c&scoped=true"
import script from "./Index-review.vue?vue&type=script&lang=js"
export * from "./Index-review.vue?vue&type=script&lang=js"
import style0 from "./Index-review.vue?vue&type=style&index=0&id=fc2d4a1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2d4a1c",
  null
  
)

export default component.exports